// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton_base__H5la_","active":"skeleton_active__8suKA","skeleton":"skeleton_skeleton__6KZdV"};